"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultAttributeFilterDraggingComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var sdk_ui_theme_provider_1 = require("@gooddata/sdk-ui-theme-provider");
var sdk_model_1 = require("@gooddata/sdk-model");
var toolkit_1 = require("@reduxjs/toolkit");
var model_1 = require("../../../model");
function isDisplayFormEqual(displayForm, identifierOrUriRef) {
    return (sdk_model_1.areObjRefsEqual(sdk_model_1.idRef(displayForm.id, displayForm.type), identifierOrUriRef) ||
        sdk_model_1.areObjRefsEqual(sdk_model_1.uriRef(displayForm.uri), identifierOrUriRef));
}
var selectFilterAttribute = function (filter) {
    return toolkit_1.createSelector(model_1.selectCatalogAttributes, function (attributes) {
        return attributes.find(function (attribute) {
            return attribute.displayForms.some(function (displayForm) {
                return isDisplayFormEqual(displayForm, filter.attributeFilter.displayForm);
            });
        });
    });
};
exports.DefaultAttributeFilterDraggingComponent = function (_a) {
    var _b, _c;
    var item = _a.item;
    var theme = sdk_ui_theme_provider_1.useTheme();
    var filterAttribute = model_1.useDashboardSelector(selectFilterAttribute(item.filter));
    if (!filterAttribute) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "attribute-filter-button is-dragging" },
        react_1.default.createElement(sdk_ui_kit_1.Icon.DragHandle, { width: 7, height: 26, className: "drag-handle-icon", color: (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.complementary) === null || _c === void 0 ? void 0 : _c.c5 }),
        react_1.default.createElement("div", { className: "button-content" },
            react_1.default.createElement("div", { className: "button-title" },
                react_1.default.createElement(sdk_ui_kit_1.ShortenedText, null, filterAttribute.attribute.title)))));
};
//# sourceMappingURL=DefaultAttributeFilterDraggingComponent.js.map